// Whether the page has the mobile layout, the breakpoint the legacy styles use.
export const isMobile = () => document.body.clientWidth <= 989;
